import { Route } from 'react-router-dom';
import { WebFormPage } from './WebFormPage';

export const webFormRoutes = [
  <Route
    key="webform"
    path="/web-form/:chatToken/*"
    element={<WebFormPage />}
  />,
];
